<template>
<div class="track">
  <div class="track-top">
    <h2>
      <div class="pastTag">{{track.is_previous?'往届热门专题':''}}</div>
      {{track.topic}}
    </h2>
    <span>
      会议室：{{track.address?track.address:'待定'}}
      <small v-if="$store.state.info.displayPresentationTime">时间：{{presentationTime?presentationTime:'待定'}}</small>
    </span>
    <h6 v-if="track.speakers && track.speakers.length"><span v-for="(speaker, key) in track.speakers" :key="key" v-if="speaker">出品人：{{speaker.name }}</span></h6>
    <h6 v-if="track.speakers && !track.speakers.length && track.speaker && track.speaker.name">出品人：{{track.speaker.name}}</h6>
    <div v-if="fullDescription || !cutDescription" class="content" v-html="track.description"></div>
    <div v-else class="content">
      <p><span v-html="cutDescription"></span>... <a class="more" @click="fullDescription=true">展开 ></a></p>
    </div>
  </div>

  <div class="tabs">
    <div class="tab" :class="{active: curTab==='presentation'}" @click="curTab='presentation'">
      <a>旗下议题</a>
    </div>
    <div class="tab" :class="{active: curTab==='speaker'}" @click="curTab='speaker'">
      <a>出品人介绍</a>
    </div>
  </div>
  <div class="track-bottom">
    <div class="presentation main-topic" v-show="curTab==='presentation'">
      <template v-if="presentations.length">
        <ul>
          <li v-for="(presentation, index) in presentations" :key="index">
            <div class="schedule-time">Topic {{index+1}}
            </div>
            <a class="schedule-detail" @click="location(presentation.id, presentation.is_previous)">
              <span class="arrow arrow_l_int"></span>
              <span class="arrow arrow_l_out"></span>
              <div class="title">{{presentation.title}}</div>
              <div class="bottom">
                <div v-for="(sid, idx) in presentation.speakerIds" :key="idx" class="speaker" :class="presentation.speakerIds.length>1?'multi':''" v-if="speakers[sid]">
                  <img :src="speakers[sid].avatar" />
                  <div class="right">
                    <h4>{{speakers[sid].name}}</h4>
                    <small>{{speakers[sid].company}}&nbsp;{{speakers[sid].position}}</small>
                  </div>
                </div>
                <div class="down">
                  <router-link :to="{path: '/search', query: {id: tags[tid].tag_id}}" v-for="(tid, idx) in presentation.tag_ids" class="l-tag" :key="idx" v-html="tags[tid].name"></router-link>
                </div>
              </div>
            </a>
          </li>
        </ul>
      </template>
      <template v-else>
        <div class="smile">
          <img src="./assets/smile.png"/>
          <h6 >更多技术大牛邀请中</h6>
        </div>
      </template>
    </div>
    <div class="speaker" v-show="curTab==='speaker'">
      <template v-if="track.speakers">
        <speaker :speaker-config="speakerConfig" v-for="(speaker, key) in track.speakers" :key="key" :speaker="speaker"></speaker>
      </template>
      <!--<template v-if="track.speaker && track.speaker.name">-->
        <!--<speaker :speaker-config="speakerConfig" :speaker="track.speaker"></speaker>-->
      <!--</template>-->
      <template v-else>
        <div class="smile">
          <img src="./assets/smile.png"/>
          <h6 >更多技术大牛邀请中</h6>
        </div>
      </template>
    </div>
  </div>
</div>
</template>

<script>
import Speaker from 'gkConUI/com-speaker'
import moment from 'moment'
import util from '@/utils'

export default {
  data () {
    return {
      curTab: 'presentation', // presentation, speaker
      fullDescription: false
    }
  },
  components: {
    Speaker
  },
  props: [
    'id'
  ],
  computed: {
    tags () {
      return this.$store.state.tags
    },
    track () {
      return this.$store.state.topics[this.id] || { lectureIds: [], description: '', speaker: {} }
    },
    presentations () {
      return this.track.lectureIds.map(id => this.$store.state.lectures[id])
    },
    speakers () {
      return this.$store.state.speakers
    },
    speakerConfig () {
      return this.$store.state.speakerConfig
    },
    presentationTime () {
      return moment(this.track.time).utcOffset('+08:00').format('MM月DD日 hh:mm')
    },
    cutDescription () {
      // return this.track.description.replace(/<[^>]+>/g, '').replace(/\s+/g, '').slice(0, 40)
      return this.track.description.replace(/^<[^>]+>/g, '').slice(0, 40)
    }
  },
  updated () {
    if (this.track.speaker) {
      util.weixinshare({
        imgUrl: this.track.speaker.avatar,
        title: this.track.topic + this.$store.state.config.wechat_share.default_title
      })
    }
  },
  mounted () {
    // this.curTab = this.presentations.length ? 'presentation' : 'speaker'
  },
  beforeDestroy () {},
  methods: {
    location (id, isPrevious) {
      if (isPrevious !== true) {
        this.$router.push({ path: '/presentation/' + id })
      }
    }
  },
  watch: {
    'presentations': {
      handler: function (n, o) {
        this.curTab = n.length ? 'presentation' : 'speaker'
      },
      immediate: true
    }
  }
}
</script>

<style lang="sass">
.track-top
  padding-bottom: 57px
  background-image: url('./assets/trackbg.png')
  background-color: rgba(var(--primary-rgb-color), 0.95)
  background-position: center bottom
  background-repeat: no-repeat
  background-blend-mode: lighten
  background-size: 100% auto
  .content
    ol,ul
      margin-top: 20px
      padding: 0 27px 0 15px
      text-align: justify
      line-height: 24px
      color: #fff
      font-size: 14px
      li
        margin-bottom: 5px
  h2
    font-size: 22px
    text-align: center
    padding: 36px 27px 0 27px
    color: #fff
    .pastTag
      font-size: 18px
  span
    display: block
    margin-top: 8px
    font-size: 13px
    text-align: center
    color: $grey-lighter
    small
      padding-left: 12px
      font-size: 13px
  a.more
    margin-left: 10px
    color: $grey-lighter
  h6
    margin-top: 16px
    font-size: 13px
    text-align: center
    color: #fff
    span
      display: inline-block
      padding: 0 2px
      color: #fff
  p
    margin-top: 20px
    padding: 0 27px
    text-align: justify
    line-height: 24px
    color: #fff
    font-size: 14px
    span
      display: inline

.tabs
  display: flex
  height: 64px
  .tab
    flex-grow: 1
    flex-basis: 0
    display: flex
    justify-content: center
    align-items: center
    border-bottom: 1px solid var(--primary-color)
    height: 100%
    cursor: pointer
    &.active
      border-bottom: 5px solid var(--primary-color)

.smile
  background-color: #f3f3f3
  padding: 100px 0
  display: flex
  flex-direction: column
  align-items: center
  > img
    width: 55px
  h6
    font-size: 14px
    color: #898989
    margin-top: 25px

.presentation
  background-color: #f3f3f3
  padding: 20px 15px
  li
    display: flex
    align-items: flex-start
    margin-top: 18px
    justify-content: space-between
    .schedule-time
      position: relative
      flex-shrink: 0
      width: 60px
      padding: 4px 0
      border-radius: 4px
      font-size: 14px
      text-align: center
      color: #fff
      background-color: var(--primary-color)
    .schedule-detail
      display: block
      background-color: #f7f7f7
      flex-grow: 1
      position: relative
      margin-left: 12px
      padding: 5px 14px
      border: 1px solid rgba(var(--primary-rgb-color), 0.7)
      .arrow
        display: block
        border: 6px solid transparent
        position: absolute
        top: 8px
        left: -13px
        border-color: transparent rgba(var(--primary-rgb-color), 0.7) transparent  transparent
      .arrow_l_out
        border-color: transparent #fff transparent transparent
        left: -12px
      .title
        font-size: 15px
        color: #3e3a39
      .bottom
        margin-top: 6px
        .down
          font-size: 12px
          padding: 0 8px
          margin: 8px 0 5px
          .l-tag
            color: #888
            padding: 2px 15px
            border: 1px solid #888
            border-radius: 15px
            margin-right: 10px
            transition: all 0.3s linear
            &:hover
              border-color: var(--primary-color)
              color: var(--primary-color)
        .speaker
          display: flex
          align-items: center
          &.multi
            margin-top: 4px
            &:first-child
              margin-top: 0
            img
              width: 45px
              height: 45px
          img
            width: 55px
            height: 55px
            border-radius: 50%
            border: 1px solid #dcdddd
          .right
            flex-grow: 1
            margin-left: 10px
            h4
              font-size: 15px
              color: rgba(var(--primary-rgb-color), 0.7)
            small
              font-size: 12px
              color: #898989

</style>
